module.exports = __webpack_public_path__ + "img/home-bg.38597fac.jpg";